import { makeStyles } from "@mui/styles";
import React from "react";

import {
  alertCSS,
  alertInfoCSS,
  alertErrorCSS,
  alertSuccessCSS,
  alertDuplicateCSS,
  alertWithInfoIconCSS,
} from "../shared/AlertCSS";
import { Grid } from "@mui/material";

// Components
import MDCButton from "./MDCButton";
//Constants
import { GLOBAL_MESSAGE_STATUS } from "../../constants/GlobalConstants";

const useStyles = makeStyles(() => ({
  alert: alertCSS,
  alertInfo: alertInfoCSS,
  alertError: alertErrorCSS,
  alertSuccess: alertSuccessCSS,
  alertDuplicate: alertDuplicateCSS,
  alertWithInfoIcon: alertWithInfoIconCSS,
}));

export default function MDCBannerDetailView({
  children,
  error,
  success,
  isDuplicate,
  isInfoIcon,
  handleMessagesDetailButton,
  actionNode,
  isIcon,
}) {
  const {
    alert,
    alertInfo,
    alertSuccess,
    alertError,
    alertDuplicate,
    alertWithInfoIcon,
  } = useStyles();

  let MDCStyles = `${alert}`;

  if (error || (isIcon && isIcon === GLOBAL_MESSAGE_STATUS.ERROR)) {
    MDCStyles = `${MDCStyles} ${alertError}`;
  } else if (success || (isIcon && isIcon === GLOBAL_MESSAGE_STATUS.SUCCESS)) {
    MDCStyles = `${MDCStyles} ${alertSuccess}`;
  } else if (
    isDuplicate ||
    (isIcon && isIcon === GLOBAL_MESSAGE_STATUS.DUPLICATE)
  ) {
    MDCStyles = `${MDCStyles} ${alertDuplicate}`;
  } else if (isInfoIcon || (isIcon && isIcon === GLOBAL_MESSAGE_STATUS.INFO)) {
    MDCStyles = `${MDCStyles} ${alertWithInfoIcon}`;
  } else {
    MDCStyles = `${MDCStyles} ${alertInfo}`;
  }

  return (
    <div className={`${MDCStyles}`}>
      <Grid
        container
        marginLeft={"0.5rem"}
        marginY={"0.5rem"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Grid item xs={actionNode ? 7 : 10}>
          {children}
        </Grid>
        <Grid item xs={actionNode ? 5 : 1.5}>
          {actionNode ? (
            actionNode
          ) : (
            <MDCButton
              variant="outlined"
              label={"Details anzeigen"}
              onClick={() => {
                handleMessagesDetailButton();
              }}
            />
          )}
        </Grid>
      </Grid>
    </div>
  );
}
